module.exports = __webpack_public_path__ + "static/media/31.21902ca2.jpg";